export enum FilterMenuItems {
  Days45,
  Days90,
  MonthCurrent,
  MonthLast,
  AllTime,
  Custom,
}
